import { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'mir-utils/i18n';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      margin: theme.spacing(0, 1),
    },
  })
);

/**
 * @summary Диалоговое окно для отображения человекочитаемой ошибки, приходящей с бэкэнда (HumanReadableError).
 *
 * @param description - Описание ошибки (human readable error), приходит с бэкэнда.
 * @param open - Флаг того, что диалоговое окно открыто.
 * @param onClose - Коллбэк при закрытии диалогового окна.
 *
 * @description Диалоговое окно, содержащее информацию о срабатывании валидации, которая проверяется только на бекенде
 * (humanReadableError).
 */
export const DialogForHumanReadableError: FC<{
  description: string;
  open: boolean;
  onClose: () => void;
}> = ({ description, open, onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Dialog open={open} maxWidth="sm" data-testid="dialogForHumanReadableError">
      <DialogContent className={classes.content}>
        <Typography variant="body2">{description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" size="small" onClick={onClose}>
          {t('OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
